// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { createSelector, Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { first, map, switchMap } from 'rxjs/operators';

import { DeeplinkDto } from 'src/app/api/vehicle-deeplinks/models';
import { OnlineCodeService } from 'src/app/core/services/online-code/online-code.service';
import { selectApiContext } from 'src/app/select-api-context';
import { selectConfigurationVehicle } from 'src/app/store/common/common.selectors';
import { fetchDeeplink } from 'src/app/utils/functions/fetch-deeplink';

export const selectApiContextAndVehicle = createSelector(
  selectApiContext,
  selectConfigurationVehicle,
  ({ country, language }, vehicle) => ({
    country,
    language,
    vehicle
  })
);

/**
 * Service to get deeplink infos for the summary page in a convenient way.
 */
@Injectable({
  providedIn: 'root'
})
export class TestdriveService {
  public constructor(
    private readonly store: Store,
    private readonly onlineCodeService: OnlineCodeService
  ) {}

  public getDeeplinkInfo(): Observable<DeeplinkDto> {
    return combineLatest([
      this.store.select(selectApiContextAndVehicle),
      this.onlineCodeService.getCurrentConfigUrlAndOnlineCode()
    ]).pipe(
      map(([{ country, language, vehicle }, { onlineCode }]) => ({ country, language, onlineCode, vehicle })),
      switchMap(({ country, language, onlineCode, vehicle }) =>
        fetchDeeplink(country, language, vehicle, onlineCode, 'TEST_DRIVE')
      ),
      first()
    );
  }
}
